import { SxProps, Theme } from '@mui/material/styles';
import { FC, memo } from 'react';

import { MenuItem } from '../../types/menu';
import Route from '../route/Route';

type DesktopListProps = {
  items: MenuItem[];
  sx: SxProps<Theme>;
};

const DesktopList: FC<DesktopListProps> = ({ items, sx }) => (
  <>
    {items.map(({ href, text }) => (
      <Route href={href} key={text} sx={sx}>
        {text}
      </Route>
    ))}
  </>
);

export default memo(DesktopList);
